/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSchemaIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-schema"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.67 20.68L3.67 19.18Q3.67 18.13 4.4 17.4Q5.13 16.68 6.17 16.68L6.17 16.68L6.17 15.32L6.17 15.32Q5.13 15.32 4.4 14.6Q3.67 13.88 3.67 12.82L3.67 11.18Q3.67 10.13 4.4 9.4Q5.13 8.68 6.17 8.68L6.17 8.68L6.17 7.33L6.17 7.33Q5.13 7.33 4.4 6.6Q3.67 5.88 3.67 4.83L3.67 3.33Q3.67 2.2 4.44 1.44Q5.2 0.68 6.33 0.68L8.68 0.68Q9.8 0.68 10.56 1.44Q11.32 2.2 11.32 3.33L11.32 4.83Q11.32 5.88 10.6 6.6Q9.88 7.33 8.82 7.33L8.82 7.33L8.82 8.68L9.32 8.68Q10.15 8.68 10.74 9.26Q11.32 9.85 11.32 10.68L11.32 10.68L13.68 10.68L13.68 10.68Q13.68 9.85 14.26 9.26Q14.85 8.68 15.68 8.68L18.68 8.68Q19.8 8.68 20.56 9.44Q21.32 10.2 21.32 11.32L21.32 12.68Q21.32 13.8 20.56 14.56Q19.8 15.32 18.68 15.32L15.68 15.32Q14.85 15.32 14.26 14.74Q13.68 14.15 13.68 13.32L13.68 13.32L11.32 13.32L11.32 13.32Q11.32 14.15 10.74 14.74Q10.15 15.32 9.32 15.32L8.82 15.32L8.82 16.68L8.82 16.68Q9.88 16.68 10.6 17.4Q11.32 18.13 11.32 19.18L11.32 20.68Q11.32 21.8 10.56 22.56Q9.8 23.32 8.68 23.32L6.33 23.32Q5.2 23.32 4.44 22.56Q3.67 21.8 3.67 20.68Z" fill={color} />
    </svg>
  );
}
